<template>
  <div>
    <div
      v-bind:style="{ width: this.progress + '%' }"
      class="progressBar"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: ["progress"],
};
</script>

<style lang="scss" scoped>
.progressBar {
  height: 5px;
  background-color: purple;
  margin-top: 20px;
}
</style>
